import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TryItOnState } from "./tryItOn.state";
import { processTryItOn } from "./tryItOn.thunk";

export const initialTryItOnState: TryItOnState = {
  humanImage: null,
  clotheImage: null,
  resultImage: null,
  isLoading: false,
  error: null,
};

const tryItOnSlice = createSlice({
  name: "tryItOn",
  initialState: initialTryItOnState,
  reducers: {
    setHumanImage: (state, action: PayloadAction<File>) => {
      state.humanImage = action.payload;
      state.error = null;
    },
    setClotheImage: (state, action: PayloadAction<string>) => {
      state.clotheImage = action.payload;
      state.resultImage = null;
      state.error = null;
    },
    clearTryItOn: (state) => {
      state.humanImage = null;
      state.clotheImage = null;
      state.resultImage = null;
      state.isLoading = false;
      state.error = null;
    },
    clearResult: (state) => {
      state.resultImage = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(processTryItOn.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.resultImage = null;
      })
      .addCase(processTryItOn.fulfilled, (state, action) => {
        state.isLoading = false;
        state.resultImage = action.payload;
        state.error = null;
      })
      .addCase(processTryItOn.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setHumanImage, setClotheImage, clearTryItOn, clearResult } =
  tryItOnSlice.actions;
export default tryItOnSlice.reducer;
